import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import I18n from 'I18n';
import { getActiveToolAccessRequestForScopeRpc, requestToolAccessRpc } from '../../__generated__/chirp/com/hubspot/tool/access/rpc/ToolAccessService';
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
export default {
  fetchRequestByScope: scope => {
    // @ts-ignore langEnabled not on I18n type def
    const lang = I18n.langEnabled ? I18n.lang : 'en';
    return rpcClient.call(getActiveToolAccessRequestForScopeRpc, {
      request: {
        scopeName: scope,
        locale: lang
      }
    });
  },
  createRequest: data => rpcClient.call(requestToolAccessRpc, {
    request: data
  })
};